module.exports = __webpack_public_path__ + "static/media/fullAMRewardsWhite.814a16c0.svg";